export default {
  overviewList: {
    search: {
      returnType: '退换货类型',
      returnTypePlaceholder: '请选择退换货类型',
      returnDepartmentCode: '业务部门',
      returnDepartmentCodePlaceholder: '请选择业务部门',
      purchaseUnitNo: '客户',
      purchaseUnitNoPlaceholder: '请选择客户',
      returnMinNo: '销售退货单号',
      returnMinNoPlaceholder: '请输入销售退货单号',
      returnMaxNo: '销售退货单号止',
      returnMaxNoPlaceholder: '请输入销售退货结束单号',
      returnMoney: '是否退款',
      returnMoneyPlaceholder: '请选择是否退款',
      changeMethod: '换货方式',
      changeMethodPlaceholder: '请选择换货方式',
      returnMethod: '退货方式',
      returnMethodPlaceholder: '请选择退货方式',
      isDirectDeliver: '是否直拨',
      isDirectDeliverPlaceholder: '请选择直拨条件',
      returnMoneyAmount: '总金额',
      returnMoneyAmountPlaceholder: '请输入总金额',
      returnRealObject: '实物退换',
      returnRealObjectPlaceholder: '请选择实物退换',
      inboundStorageNo: '入库仓库',
      inboundStorageNoPlaceholder: '请选择入库仓库',
      returnSalesmanCode: '业务员',
      returnSalesmanCodePlaceholder: '请选择业务员',
      ladingMinNo: '提单号',
      ladingMinNoPlaceholder: '请输入提单单号',
      ladingMaxNo: '提单号止',
      ladingMaxNoPlaceholder: '请输入提单结束单号',
      returnStatus: '退货单状态',
      returnStatusPlaceholder: '请选择退货单状态',
      outboundStorageNo: '出库仓库',
      outboundStorageNoPlaceholder: '请选择出库仓库',
      returnOperatorCode: '操作人',
      returnOperatorCodePlaceholder: '请选择操作人',
      exchangeMinNo: '销售换货单号起',
      exchangeMinNoPlaceholder: '请输入销售换货单开始单号',
      exchangeMaxNo: '销售换货单号止',
      exchangeMaxNoPlaceholder: '请输入销售换货单结束单号',
      createStartDate: '制单日期',
      createStartDatePlaceholder: '请选择制单日期',
      createEndDate: '制单日期',
      createEndDatePlaceholder: '请选择制单日期',
      deliveryExpenseTaker: '运费承担',
      deliveryExpenseTakerPlaceholder: '请选择运费承担',
      predictExchangeStartDate: '预计换货日期开始',
      predictExchangeStartDatePlaceholder: '请选择预计换货日期开始时间',
      predictExchangeEndDate: '预计换货日期结束',
      predictExchangeEndDatePlaceholder: '请选择预计换货日期结束时间',
      predictReturnStartDate: '预计退货日期',
      predictReturnStartDatePlaceholder: '请选择预计退货日期',
      predictReturnEndDate: '预计退货日期结束',
      predictReturnEndDatePlaceholder: '请选择预计退货日期结束时间',
      actualSendQuantity: '实发数量',
      nonInvoiceQuantity: '未开票总数量',
      nonInvoiceQuantityPlaceholder: '请输入未开票总数量',
      nonInvoiceQuantityFlag: '未开票总数量比较标记',
      nonInvoiceQuantityFlagPlaceholder: '请选择未开票总数量比较标记',
      invoiceAmount: '已开票金额',
      invoiceAmountPlaceholder: '请输入已开票金额',
      invoiceAmountFlag: '已开票金额比较标记',
      invoiceAmountFlagPlaceholder: '请选择已开票金额比较标记',
      tradeType: '贸易类型',
      tradeTypePlaceholder: '请选择贸易类型',
      actualInboundQuantity: '实际入库数量',
      actualInboundQuantityPlaceholder: '请输入实际入库数量',
      actualInboundQuantityFlag: '实际入库比较标记',
      actualInboundQuantityFlagPlaceholder: '请选择实际入库比较标记',
      large: '大于',
      small: '小于',
      equal: '等于',
      notEqual: '不等于',
      ZT02: '审批中',
      ZT03: '审批完成',
      ZT04: '已禁用',
      ZT05: '审批驳回',
      ZT06: '已保存',
      ZT07: '已开提单',
    },
    table: {
      title: '序号',
      gmtCreate: '制单时间',
      returnNo: '销售退货单号',
      // returnType: '业务类型',
      returnRealObject: '实物退换',
      ladingNo: '提单号',
      purchaseUnitName: '客户',
      returnStatusName: '退货单状态',
      isDirectDeliver: '是否直拨',
      predictExchangeAddress: '预计退货日期',
      returnMoneyAmount: '退款总金额',
      deliveryExpenseTaker: '运费承担',
      returnMethod: '退货方式',
      // changeMethod: '换货方式',
      // outboundStorageName: '出库仓库',
      inboundStorageName: '入库仓库',
      returnDepartmentName: '业务部门',
      returnSalesmanName: '业务员',
      returnOperatorName: '操作人',
      // actualSendQuantity: '实发数量',
      nonInvoiceQuantity: '未开票总数量',
      invoiceAmount: '已开票金额',
      tradeType: '贸易类型',
      actualInboundQuantity: '实际入库数量',
    },
  },
  returnDetail: {
    collapseTitle: {
      baseTitle: '基本信息',
      returnGoodsTitle: '退货商品明细',
      changeGoodsTitle: '换货商品明细',
      fileTitle: '附件上传',
    },
    msg: {
      submitSusscess: '提交成功！',
      updateSusscess: '修改成功！',
      saveSussess: '新增成功！',
      makeSuccess: '操作成功！',
      removeSussess: '删除成功！',
      success: '成功！',
      error: '失败！',
      comfirmSusscess: '确认成功！',
      goodsMsg: '请填写退货商品明细',
      removeMsg: '您还没选择想要删除的数据',
      selectTip: '请选择一条数据',
      transTip: '该退换货单已生成物流运输单，请选择其他单号',
      transSuccess: '生成运输单成功！',
      transFailed: '生成运输单失败！',
      statusError: '无法生成运输单,请检查单据状态',
      quantityTip: '退换货数量不符合要求，请查看选择的退换货明细',
      returnDepartmentCode: '请选择业务部门',
      purchaseUnitNo: '请选择客户',
      inboundStorageName: '请选择入库仓库',
      storageMsg: '销售出库仓库与行项目仓库不一致',
      sureInvoiceMsg: '请确认实际入库数量，将按照该数量进行开票',
      contractNo: '请选择合同号',
    },
    path: {
      addPathName: '销售退货单创建',
      listPathName: '销售退换货总览',
      editPathName: '销售退货单编辑',
    },
    btnList: {
      save: '保存',
      submit: '提交',
      shippingOrder: '生成运输单',
      upload: '上传附件',
      print: '打印',
      add: '新增',
      remove: '删除',
      copy: '复制',
      ladeOrder: '提单',
      viewLadeOrder: '查看提单',
    },
    baseForm: {
      changeNo: '销售换货单号',
      returnNo: '销售退货单号',
      isDirectDeliver: '是否直拨',
      isDirectDeliverPlaceholder: '请选择直拨条件',
      changeNoPlaceholder: '请输入销售换货单号',
      returnNoPlaceholder: '请输入销售退货单号',
      returnDepartmentCode: '业务部门',
      returnDepartmentCodePlaceholder: '请选择业务部门',
      returnOperatorCode: '操作人',
      returnOperatorCodePlaceholder: '请选择操作人',
      returnSalesmanCode: '业务员',
      returnSalesmanCodePlaceholder: '请选择业务员',
      returnCompanyCode: '公司',
      returnCompanyCodePlaceholder: '请选择公司',
      purchaseUnitNo: '客户',
      purchaseUnitNoPlaceholder: '请选择客户',
      gmtCreate: '制单日期',
      gmtCreatePlaceholder: '请选择制单日期',
      returnRealObject: '实物退换',
      returnRealObjectPlaceholder: '请选择实物退换',
      returnMethod: '退货方式',
      returnMethodPlaceholder: '请选择退货方式',
      returnMoney: '是否退款',
      returnMoneyPlaceholder: '请选择是否退款',
      returnMoneyMethod: '退款方式',
      returnMoneyMethodPlaceholder: '请选择退款方式',
      changeMethod: '换货方式',
      changeMethodPlaceholder: '请选择换货方式',
      exchangeAddress: '换货地点',
      exchangeAddressPlaceholder: '请输入换货地点',
      returnMoneyAmount: '总金额',
      returnMoneyAmountPlaceholder: '请输入总金额',
      deliveryAddress: '客户交货地点',
      deliveryAddressPlaceholder: '请输入客户交货地点',
      predictReturnAddress: '预计退货日期',
      predictReturnAddressPlaceholder: '请选择预计退货日期',
      predictExchangeAddress: '预计换货日期',
      predictExchangeAddressPlaceholder: '请选择预计换货日期',
      inboundStorageNo: '入库仓库',
      inboundStorageNoPlaceholder: '请选择入库仓库',
      outboundStorageNo: '销售出库仓库',
      outboundStorageNoPlaceholder: '请选择销售出库仓库',
      outboundExpenseTaker: '出库费承担',
      outboundExpenseTakerPlaceholder: '请选择出库费承担',
      outboundExpenseAmount: '出库费金额',
      outboundExpenseAmountPlaceholder: '请选择出库费金额',
      deliveryMethod: '运输方式',
      deliveryMethodPlaceholder: '请选择运输方式',
      deliveryExpenseTaker: '运费承担',
      deliveryExpenseTakerPlaceholder: '请选择运费承担',
      deliveryExpenseAmount: '运费金额',
      deliveryExpenseAmountPlaceholder: '请输入运费金额',
      inboundExpenseTaker: '入库费承担',
      inboundExpenseTakerPlaceholder: '请选择入库费承担',
      inboundExpenseAmount: '入库费金额',
      inboundExpenseAmountPlaceholder: '请输入入库费金额',
      currencyCode: '货币',
      currencyCodePlaceholder: '请选择货币',
      totalReturnQuantity: '总退货数量',
      totalReturnQuantityPlaceholder: '请输入总退货数量',
      totalExchangeQuantity: '总换货数量',
      totalExchangeQuantityPlaceholder: '请输入总换货数量',
      mark: '备注',
      markPlaceholder: '请输入备注',
      nonInvoiceQuantity: '未开票总数',
      nonInvoiceQuantityPlaceholder: '请输入未开票总数',
      tradeType: '贸易类型',
      tradeTypePlaceholder: '请选择贸易类型',
      invoiceAmount: '已开票金额',
      invoiceAmountPlaceholder: '请输入已开票金额',
      contractNo: '销售合同号',
      contractNoPlaceholder: '请选择销售合同号',
    },
    goodsTable: {
      indexTitle: '序号',
      productDesc: '商品描述',
      unit: '单位',
      ladingNo: '提单号',
      ladingDetailNo: '提单行项目号',
      availableReturnQuantity: '可退货数量',
      availableChangeQuantity: '可换货数量',
      returnQuantity: '退货数量',
      changeQuantity: '换货数量',
      actualInboundQuantity: '实际入库数量',
      actualSendQuantity: '实际出库数量(物流反馈)',
      // actualInboundQuantity: '实际入库数量(物流反馈)',
      contractUnitPrice: '合同单价',
      returnUnitPrice: '退货单价',
      returnMoneyAmount: '金额',
      deliveryExpenseUnitPrice: '运费单价',
      invoiceQuantity: '已开票数量',
      nonInvoiceQuantity: '未开票数量',
      invoiceAmount: '已开票金额',
      businessInboundBatchNo: '业务入库批次',
      batchNo: '新业务入库批次',
    },
    goodsTableEditRules: {
      productDesc: '请选择商品描述',
      ladingNo: '请输入提货单号',
      returnQuantity: '请输入退货数量',
      returnUnitPrice: '请输入退货单价',
      businessInboundBatchNo: '请选择业务入库批次',
    },
    businessInbound: {
      ladingNo: '提单号',
      ladingDetailNo: '提单行项目号',
      businessInboundBatchNo: '业务批次号',
      availableReturnQuantity: '可退货数量',
      pickingQuantity: '拣配数量',
      productNo: '商品编码',
      productDesc: '商品描述',
      unitName: '单位',
      businessContractUnitPrice: '单价',
    },
  },
};
